import React, { createRef, useEffect } from "react";
import { Loading } from "../state/Loading";

var OnboardingFeatureMedia = function OnboardingFeatureMedia(props) {
  var _Features$value, _Features$value2;

  var Features = props.Features,
      play = props.play;
  var vidRef = createRef();
  useEffect(function () {
    play ? playVideo() : stopVideo();
  }, [play]);

  var playVideo = function playVideo() {
    var _vidRef$current;

    if (!vidRef.current) return;
    vidRef.current.currentTime = 0;
    (_vidRef$current = vidRef.current) === null || _vidRef$current === void 0 ? void 0 : _vidRef$current.play();
  };

  var stopVideo = function stopVideo() {
    var _vidRef$current2;

    if (!vidRef.current) return;
    (_vidRef$current2 = vidRef.current) === null || _vidRef$current2 === void 0 ? void 0 : _vidRef$current2.pause();
    vidRef.current.currentTime = 0;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "onboarding-feature--media"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: true
  }), /*#__PURE__*/React.createElement("video", {
    height: "100%",
    width: "100%",
    autoPlay: false,
    controls: false,
    muted: true,
    playsInline: true,
    loop: true,
    name: "media",
    ref: vidRef
  }, /*#__PURE__*/React.createElement("source", {
    src: Features === null || Features === void 0 ? void 0 : (_Features$value = Features.value) === null || _Features$value === void 0 ? void 0 : _Features$value.src,
    type: Features === null || Features === void 0 ? void 0 : (_Features$value2 = Features.value) === null || _Features$value2 === void 0 ? void 0 : _Features$value2.mimeType
  }), "Your browser does not support the video tag."));
};

export default OnboardingFeatureMedia;